// src/features/settings/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import SettingsPage from './pages/SettingsPage';
import { SETTINGS_WRITE_SCOPES } from './settingsScopes';

export const SettingsRoutes = () => (
  <Route path="settings">
    <Route
      index
      element={
        <ProtectedRoute requiredScopes={SETTINGS_WRITE_SCOPES}>
          <SettingsPage />
        </ProtectedRoute>
      }
    />
  </Route>
);
